export enum InputType {
  Text = "text",
  Email = "email",
  Password = "password",
  Phone = "tel",
  File = "file",
}
